import FastImage from '@d11/react-native-fast-image';
import {
  WELCOME_WALL_IMAGES,
  ONBOARDING_SLIDES,
} from '../constants/onboarding';
import { DEMO_PRODUCTS } from '../models/demo/demoData';
import { forceHttps } from './libs';

type PreloadPriority = 'high' | 'normal' | 'low';

const DEMO_INTRO_ILLUSTRATION_URL =
  'https://res.cloudinary.com/dbi34vmol/image/upload/v1754740115/samples/people/orderprocessing_gjiyxf.png';

const uniq = (arr: Array<string | null | undefined>) =>
  Array.from(new Set(arr.filter(Boolean) as string[]));

const toFastImageSource = (uri: string, priority: PreloadPriority) => ({
  uri: forceHttps(uri),
  priority: FastImage.priority[priority],
  cache: FastImage.cacheControl.immutable,
});

const preload = (uris: string[], priority: PreloadPriority) => {
  if (!uris.length) return;
  FastImage.preload(uris.map(u => toFastImageSource(u, priority)));
};

const deferNonCriticalWork = (cb: () => void) => {
  const g: any = globalThis as any;
  if (typeof g?.requestIdleCallback === 'function') {
    g.requestIdleCallback(cb, { timeout: 1500 });
    return;
  }

  // Let the first paint/layout settle before doing background preloads.
  if (typeof g?.requestAnimationFrame === 'function') {
    g.requestAnimationFrame(() => {
      g.requestAnimationFrame(() => {
        setTimeout(cb, 150);
      });
    });
    return;
  }

  setTimeout(cb, 250);
};

export function startPreAuthImagePreload() {
  // Wave 1: Welcome (immediate, high priority)
  try {
    preload(uniq(WELCOME_WALL_IMAGES), 'high');
  } catch {
    // best-effort
  }

  // Wave 2+3: deferred (avoid competing with initial render)
  deferNonCriticalWork(() => {
    try {
      const demo = uniq([
        DEMO_INTRO_ILLUSTRATION_URL,
        ...DEMO_PRODUCTS.map(p => p.bp_product_image),
      ]);
      preload(demo, 'normal');
    } catch {
      // best-effort
    }

    setTimeout(() => {
      try {
        const onboarding = uniq(ONBOARDING_SLIDES.map(s => s.image));
        preload(onboarding, 'low');
      } catch {
        // best-effort
      }
    }, 700);
  });
}
